export default "__VITE_ASSET__DYBTbH6b__"